import React, { useState } from "react";
import {
  Button,
  Col,
  Container,
  Offcanvas,
  OffcanvasBody,
  Row,
} from "reactstrap";
import editWhiteIcon from "../../../../assets/icon/edit-white-icon.svg";
import CloseIcon from "../../../../assets/icon/chatClose.svg";
import saveIcon from "../../../../assets/icon/save-btn-icon-white.svg";
import RefreshWhiteIcon from "../../../../assets/icon/refresh-white.svg";
import RefreshPrupleIcon from "../../../../assets/icon/refresh-purple.svg";

import PatientEditInfo from "./PatientEditInfo";
import { useLocation } from "react-router-dom";

const BasicInfo = () => {
  const location = useLocation();
  const rowData = location.state;
  console.log(rowData, 222);

  const [editInfoDetails, setEditInfoDetails] = useState(false);
  const [data, setData] = useState({
    lastname: "",
    firstname: "",
    dateofbirth: "",
    primaryphone: "",
    streetaddress1: "",
    streetaddress2: "",
  });
  return (
    <>
      <Container fluid className="basic-info-body">
        <Container
          className="p-8"
          fluid
          style={{
            height: "57vh",
            overflowX: "hidden",
            overflowY: "auto",
            scrollbarWidth: "thin",
          }}
        >
          <Row className="patient-info">
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">Last Name</div>
              <div className="patient-info-page">{rowData.lastname}</div>
            </Col>
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">First Name</div>
              <div className="patient-info-page">{rowData.firstname}</div>
            </Col>
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">Middle Name</div>
              <div className="patient-info-page">-</div>
            </Col>
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">Date of Birth</div>
              <div className="patient-info-page">01/08/1996</div>
            </Col>
          </Row>
          <Row className="patient-info" style={{ marginTop: "12px" }}>
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">Gender</div>
              <div className="patient-info-page">Male</div>
            </Col>
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">Name Prefix</div>
              <div className="patient-info-page">Dr</div>
            </Col>
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">Name Suffix</div>
              <div className="patient-info-page">-</div>
            </Col>
          </Row>
          <div
            style={{
              border: "1px solid #D3D3D3",
              margin: "16px 0px 0px 0px",
            }}
          ></div>
          <Row className="patient-info">
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">Address Line-1</div>
              <div className="patient-info-page">1234c</div>
            </Col>
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">Address Line-2</div>
              <div className="patient-info-page">Maple Road</div>
            </Col>
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">City</div>
              <div className="patient-info-page">Jercy city</div>
            </Col>
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">State/Province</div>
              <div className="patient-info-page">New Jercy</div>
            </Col>
          </Row>
          <Row className="patient-info" style={{ marginTop: "12px" }}>
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">Zip/Postal Code</div>
              <div className="patient-info-page">1234567</div>
            </Col>

            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">Primary Phone</div>
              <div className="patient-info-page">(555)-1234-1234</div>
            </Col>
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">Secondary Phone</div>
              <div className="patient-info-page">-</div>
            </Col>
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">Email</div>
              <div className="patient-info-page">Lorume@gmail.com</div>
            </Col>
          </Row>
          <div
            style={{
              border: "1px solid #D3D3D3",
              margin: "16px 0px 0px 0px",
            }}
          ></div>
          <Row className="patient-info" style={{ marginTop: "12px" }}>
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">Automatic Refills</div>
              <div className="patient-info-page">True</div>
            </Col>
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">Primary Prescriber</div>
              <div className="patient-info-page">-</div>
            </Col>
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">Preferred Language</div>
              <div className="patient-info-page">English</div>
            </Col>
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">Requires Translation</div>
              <div className="patient-info-page">No</div>
            </Col>
          </Row>
          <Row className="patient-info" style={{ marginTop: "12px" }}></Row>

          <Row>
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">Child Safety Caps</div>
              <div className="patient-info-page">Yes</div>
            </Col>
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">Hipaa Acknowledged Date</div>
              <div className="patient-info-page">11/12/2004</div>
            </Col>
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">Hipaa Acknowledgement</div>
              <div className="patient-info-page">-</div>
            </Col>
          </Row>
          <Row className="patient-info" style={{ marginTop: "12px" }}>
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">Note</div>
              <div className="patient-info-page">-</div>
            </Col>
          </Row>

          <div
            style={{
              border: "1px solid #D3D3D3",
              margin: "16px 0px 0px 0px",
            }}
          ></div>
          <Row className="patient-info" style={{ marginTop: "12px" }}>
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">County</div>
              <div className="patient-info-page">Travis</div>
            </Col>
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">Country</div>
              <div className="patient-info-page">United States</div>
            </Col>
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">SSN</div>
              <div className="patient-info-page">123456455</div>
            </Col>
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">Marital Status</div>
              <div className="patient-info-page">Married</div>
            </Col>
          </Row>
          <Row className="patient-info" style={{ marginTop: "12px" }}></Row>
          <Row>
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">Race</div>
              <div className="patient-info-page">White</div>
            </Col>
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">Ethnicity</div>
              <div className="patient-info-page">Not Hispanic or Latino</div>
            </Col>
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">Mother's Maiden Name</div>
              <div className="patient-info-page">Ramirez</div>
            </Col>
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">Deceased</div>
              <div className="patient-info-page">Yes</div>
            </Col>
          </Row>
          <Row className="patient-info" style={{ marginTop: "12px" }}></Row>

          <Row>
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">Deceased Date</div>
              <div className="patient-info-page">-</div>
            </Col>
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">Residence Code</div>
              <div className="patient-info-page">01 – Home</div>
            </Col>
          </Row>

          <div
            style={{
              border: "1px solid #D3D3D3",
              margin: "16px 0px 0px 0px",
            }}
          ></div>
          <Row className="patient-info" style={{ marginTop: "12px" }}>
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">Veterinary Patient</div>
              <div className="patient-info-page">Yes</div>
            </Col>
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">Species</div>
              <div className="patient-info-page">-</div>
            </Col>
            <Col sm={3} lg={3} md={3}>
              <div className="invHeadDetails">Owner's Name</div>
              <div className="patient-info-page">-</div>
            </Col>
          </Row>
        </Container>
        <Container fluid className="basic-info-footer mb-1">
          <Button color="primary" onClick={() => setEditInfoDetails(true)}>
            <img src={editWhiteIcon} /> Edit
          </Button>
        </Container>
      </Container>
      <div>
        <Offcanvas
          direction="end"
          isOpen={editInfoDetails}
          toggle={() => setEditInfoDetails(!editInfoDetails)}
        >
          <div className="casvas-header p-3 pb-2">
            <div>Edit Patient Details </div>

            <div
              className="cursor-pointer"
              onClick={() => setEditInfoDetails(!editInfoDetails)}
            >
              <img src={CloseIcon} />
            </div>
          </div>
          <div className="section-devider-border-popup mb-3"></div>
          <OffcanvasBody className="p-4 pt-1">
            <PatientEditInfo />
          </OffcanvasBody>
          <div className="basic-edit-footer">
            <Button
              color="primary"
              style={{ opacity: !data.firstname ? "0.4" : "", color: "black" }}
              className="reset"
              disabled
            >
              <img
                src={
                  !data.firstname || !data.lastname
                    ? RefreshWhiteIcon
                    : RefreshPrupleIcon
                }
              />{" "}
              Reset
            </Button>
            <Button
              style={{
                opacity: !data.firstname ? "0.2" : "",
                backgroundColor: "#D3D3D3",
              }}
              color="#757575"
            >
              <img src={saveIcon} />
              Save
            </Button>
          </div>
        </Offcanvas>
      </div>
    </>
  );
};

export default BasicInfo;
